var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasketSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 8 16.001 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 13h4v-3h-4zm9.788.385A1 1 0 0 0 22 13h-3V9a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v4H8a.998.998 0 0 0-.971 1.242l2 7A1 1 0 0 0 10 22h10c.46 0 .86-.312.971-.758l2-7a1 1 0 0 0-.183-.857"
})));
export default SvgBasketSolid;